import React, { useContext } from 'react';
import { SourceContext } from '../../utils/sourceContext';
import styles from './AffiliateHero.module.css';

function AffiliateHero() {
    const { source } = useContext(SourceContext);
    const sponsorName = source && source !== 'tb2'
        ? source.replace(/[^a-zA-Z0-9]+/g, ' ').trim().toUpperCase()
        : '';

    const handleScrollToSignup = (e) => {
        e.preventDefault();
        const target = document.getElementById('affiliate-signup');
        if (target) {
            const top = target.getBoundingClientRect().top + window.pageYOffset - 70;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <section className={styles.hero}>
            <div className={styles.inner}>
                <div className={styles.textCol}>
                    <div className={styles.eyebrow}>
                        <span className={styles.eyebrowGreen}>Now accepting affiliates</span>
                        <span className={styles.eyebrowDark}>$0 to join</span>
                    </div>
                    <h1 className={styles.h1}>
                        Earn real income sharing the{' '}
                        <span className={styles.grad}>GLP-1 solution</span>{' '}
                        people want
                    </h1>
                    {sponsorName && (
                        <p className={styles.sponsored}>
                            Introduced by{' '}
                            <span className={styles.sponsoredSource}>{sponsorName}</span>
                        </p>
                    )}
                    <p className={styles.sub}>
                        Four-tier commission structure. No inventory. No cold calls. Just share your link and get paid.
                    </p>
                    <button className={styles.cta} onClick={handleScrollToSignup}>
                        Start earning today
                    </button>
                </div>

                <div className={styles.cardCol}>
                    <div className={styles.card}>
                        <p className={styles.cardLabel}>HOW ONE $747 SALE PAYS</p>
                        <p className={styles.cardBigNum}>$261.45</p>
                        <p className={styles.cardSub}>
                            Marketing pool per quarterly sale, split across four tiers in your chain.
                        </p>
                        <div className={styles.tiers}>
                            <div className={styles.tierRow}>
                                <div className={styles.tierLeft}>
                                    <span className={styles.tierLevel}>L1</span>
                                    <span className={styles.tierDesc}>Direct seller</span>
                                    <span className={styles.tierPct}>57.14%</span>
                                </div>
                                <span className={styles.tierVal}>$149.39</span>
                            </div>
                            <div className={styles.tierRow}>
                                <div className={styles.tierLeft}>
                                    <span className={styles.tierLevel}>L2</span>
                                    <span className={styles.tierDesc}>1st up</span>
                                    <span className={styles.tierPct}>14.29%</span>
                                </div>
                                <span className={styles.tierVal}>$37.36</span>
                            </div>
                            <div className={styles.tierRow}>
                                <div className={styles.tierLeft}>
                                    <span className={styles.tierLevel}>L3</span>
                                    <span className={styles.tierDesc}>2nd up</span>
                                    <span className={styles.tierPct}>11.43%</span>
                                </div>
                                <span className={styles.tierVal}>$29.88</span>
                            </div>
                            <div className={styles.tierRow}>
                                <div className={styles.tierLeft}>
                                    <span className={styles.tierLevel}>L4</span>
                                    <span className={styles.tierDesc}>3rd up</span>
                                    <span className={styles.tierPct}>11.43%</span>
                                </div>
                                <span className={styles.tierVal}>$29.88</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AffiliateHero;
